export function isProductionEnvironment() {
  return typeof process !== 'undefined' && process.env?.NODE_ENV === 'production';
}
